const CLOUD_URL = "https://res.cloudinary.com/osperb/image/upload/"
const folder = "BatteryWorld"

export const amaron_p1 = CLOUD_URL + `/v1668941818/${folder}/amaron_battery.jpg`
export const amaron_p2 = CLOUD_URL + `/v1668946047/${folder}/amaron_battery_p2_dink8w.jpg`
export const exide_p1 = CLOUD_URL + `/v1668943413/${folder}/exide_battery.jpg`
export const exide_p2 = CLOUD_URL + `/v1668945847/${folder}/exide_battery_p1.jpg`
export const service1 = CLOUD_URL + `/v1668941841/${folder}/service_banner.png`
export const nduron_p1 = CLOUD_URL + `/v1668946255/${folder}/nduron_battery_axsuej.jpg`
export const solar1 = CLOUD_URL + `/v1669019167/${folder}/solar_banner1_tvua17.jpg`
export const solar2 = CLOUD_URL + `/v1669019168/${folder}/solar_banner2_ej0i5w.jpg`
export const homeBanner = CLOUD_URL + `/v1669023173/${folder}/homeBanner_kmwphy.png`

export const indecs1 = CLOUD_URL + `/v1669023173/${folder}/indecs1.jpg`
export const indecs2 = CLOUD_URL + `/v1669023173/${folder}/indecs2.jpg`
export const indecs3 = CLOUD_URL + `/v1669023173/${folder}/indecs3.jpg`
export const indecs4 = CLOUD_URL + `/v1669023173/${folder}/indecs4.jpg`


